
import { showToast } from '/src/v4/toast.js';

const seed = [
  { desc: 'Gentelella Pro license', sub: 'Annual subscription · 50 seats', qty: 1, rate: 2499 },
  { desc: 'Custom theme development', sub: 'Branded variant · 24h', qty: 24, rate: 120 },
  { desc: 'Priority support', sub: '12 months · 4h response SLA', qty: 12, rate: 99 },
  { desc: 'Onboarding workshop', sub: 'Half-day remote session', qty: 1, rate: 450 }
];

const fmt = (n) => '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const lines = document.getElementById('line-items');

function rowHtml(item, i) {
  return `
    <div class="line-row" data-i="${i}">
      <div class="desc-wrap">
        <input type="text" class="desc" value="${item.desc.replace(/"/g, '&quot;')}" placeholder="Item description" aria-label="Item description">
        <input type="text" class="desc desc-sub" value="${item.sub.replace(/"/g, '&quot;')}" placeholder="Optional details" aria-label="Item details">
      </div>
      <input type="number" class="qty" aria-label="Quantity" value="${item.qty}" min="0" step="1">
      <input type="number" class="rate" aria-label="Rate" value="${item.rate}" min="0" step="0.01">
      <div class="amount">${fmt(item.qty * item.rate)}</div>
      <button type="button" class="remove-btn" aria-label="Remove">
        <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h10M8 6V4a1.5 1.5 0 013 0v2"/><path d="M5 6l1 8.5h6L13 6"/></svg>
      </button>
    </div>
  `;
}

function render() {
  lines.innerHTML = seed.map(rowHtml).join('');
  recompute();
}

function recompute() {
  let subtotal = 0;
  document.querySelectorAll('#line-items .line-row').forEach((row, idx) => {
    const qty = parseFloat(row.querySelector('.qty').value) || 0;
    const rate = parseFloat(row.querySelector('.rate').value) || 0;
    const amount = qty * rate;
    row.querySelector('.amount').textContent = fmt(amount);
    subtotal += amount;
    if (seed[idx]) {
      seed[idx].qty = qty;
      seed[idx].rate = rate;
      seed[idx].desc = row.querySelector('.desc:not(.desc-sub)').value;
      seed[idx].sub = row.querySelector('.desc-sub').value;
    }
  });

  const dPct = parseFloat(document.getElementById('t-discount').value) || 0;
  const tPct = parseFloat(document.getElementById('t-tax').value) || 0;
  const dAmount = subtotal * dPct / 100;
  const afterDiscount = subtotal - dAmount;
  const tAmount = afterDiscount * tPct / 100;
  const grand = afterDiscount + tAmount;

  document.getElementById('t-subtotal').textContent = fmt(subtotal);
  document.getElementById('t-discount-amount').textContent = '−' + fmt(dAmount);
  document.getElementById('t-tax-amount').textContent = fmt(tAmount);
  document.getElementById('t-grand').textContent = fmt(grand);
}

lines.addEventListener('input', recompute);
lines.addEventListener('click', (e) => {
  const btn = e.target.closest('.remove-btn');
  if (!btn) return;
  const row = btn.closest('.line-row');
  const i = parseInt(row.dataset.i, 10);
  seed.splice(i, 1);
  render();
});

document.getElementById('add-line').addEventListener('click', () => {
  seed.push({ desc: 'New item', sub: '', qty: 1, rate: 0 });
  render();
  // Focus the new row's description
  const last = lines.querySelector('.line-row:last-child .desc');
  if (last) { last.focus(); last.select(); }
});

document.getElementById('t-discount').addEventListener('input', recompute);
document.getElementById('t-tax').addEventListener('input', recompute);

// Mark as paid → flip status pill + advance the payment timeline
const statusPill = document.getElementById('status-pill');
const ipsPaid = document.getElementById('ips-paid');
const paidBtn = document.getElementById('mark-paid-btn');
let paid = false;
paidBtn.addEventListener('click', () => {
  paid = !paid;
  if (paid) {
    statusPill.className = 'status status-green';
    statusPill.textContent = 'Paid';
    ipsPaid.classList.add('paid');
    ipsPaid.querySelector('.ips-time').textContent = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    paidBtn.textContent = 'Mark unpaid';
    showToast('Marked as paid', { variant: 'success' });
  } else {
    statusPill.className = 'status status-yellow';
    statusPill.textContent = 'Pending';
    ipsPaid.classList.remove('paid');
    ipsPaid.querySelector('.ips-time').textContent = '—';
    paidBtn.textContent = 'Mark as paid';
    showToast('Marked unpaid');
  }
});

render();
